import './ScrollDown.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';

export default function ScrollDown() {
  return (
    <section className="section-scroll-down">
      <h2 className="scroll-text">Scroll down</h2>
      <div className='chevron-1'>
        <FontAwesomeIcon icon={faChevronDown} />
      </div>
      <div className='chevron-2'>
        <FontAwesomeIcon icon={faChevronDown} />
      </div>
    </section>
  );
}